import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent {
  //#region Inputs

  @Input() icon?: string;
  @Input() label?: string;
  @Input() color = 'dark-grey';
  @Input() size = 'standard';
  @Input() dataTestId: string;

  //#endregion
}
